(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bar-timer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'dropky-offer-countdown';
    if (customElements.get(elementName)) return;

    class DropkyOfferCountdown extends HTMLElement {
      connectedCallback() {
        this._connectedVersion = (this._connectedVersion || 0) + 1;
        const version = this._connectedVersion;
        queueMicrotask(() => {
          if (this.isConnected && version === this._connectedVersion) this.start();
        });
      }

      disconnectedCallback() {
        this._connectedVersion = (this._connectedVersion || 0) + 1;
        this.stop();
      }

      stop() {
        window.clearInterval(this._interval);
        this._interval = null;
        if (this._onVisibility) document.removeEventListener('visibilitychange', this._onVisibility);
        this._onVisibility = null;
      }

      start() {
        this.stop();
        this.hidden = true;
        this._expired = false;
        this._lastAccessible = '';
        this._editor = this.dataset.editor === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
        this._activeRow = this.querySelector('[data-active-row]');
        this._expiredRow = this.querySelector('[data-expired-row]');
        this._note = this.querySelector('[data-editor-note]');
        this._accessible = this.querySelector('[data-countdown-accessible]');
        this._nodes = {};
        this.querySelectorAll('[data-countdown-value]').forEach((node) => {
          this._nodes[node.dataset.countdownValue] = node;
        });
        if (!this._activeRow || !this._expiredRow) return;
        this._activeRow.hidden = false;
        this._expiredRow.hidden = true;
        if (this._note) this._note.hidden = true;
        this.removeAttribute('data-expired');
        this.removeAttribute('data-preview');
        this._reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._animate = this.dataset.animate === 'true';
        this._animationStyle = this.dataset.animationStyle || 'flip';
        this._animationDuration = Math.max(100, Math.min(600, Number(this.dataset.animationDuration) || 260));

        if (this.dataset.enabled !== 'true') {
          if (this._editor) this.preview('Bara este dezactivată. Activează „Afișează bara” pentru a o vedea pe site.');
          return;
        }

        this._deadline = this.resolveDeadline();
        if (!Number.isFinite(this._deadline)) {
          if (this._editor) this.preview('Previzualizare: completează un termen valid, în formatul 2026-10-22T23:59:00+03:00. Bara rămâne ascunsă pe site până la o configurare validă.');
          return;
        }

        this.hidden = false;
        this.tick();
        if (this._expired) return;
        this._onVisibility = () => {
          window.clearInterval(this._interval);
          this._interval = null;
          if (!document.hidden) {
            this.tick();
            if (!this._expired) this._interval = window.setInterval(() => this.tick(), 1000);
          }
        };
        document.addEventListener('visibilitychange', this._onVisibility);
        if (!document.hidden) this._interval = window.setInterval(() => this.tick(), 1000);
      }

      resolveDeadline() {
        const value = (this.dataset.endDatetime || '').trim();
        const match = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?(Z|([+-])(\d{2}):(\d{2}))$/);
        if (!match) return NaN;
        const [year, month, day, hour, minute, second] = match.slice(1, 7).map(Number);
        if (year < 2000 || month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59 || second > 59) return NaN;
        const millisecond = Number((match[7] || '').padEnd(3, '0'));
        const naiveUTC = Date.UTC(year, month - 1, day, hour, minute, second, millisecond);
        const checked = new Date(naiveUTC);
        if (checked.getUTCFullYear() !== year || checked.getUTCMonth() + 1 !== month || checked.getUTCDate() !== day) return NaN;
        let offset = 0;
        if (match[8] !== 'Z') {
          const offsetHours = Number(match[10]);
          const offsetMinutes = Number(match[11]);
          if (offsetHours > 14 || offsetMinutes > 59 || (offsetHours === 14 && offsetMinutes !== 0)) return NaN;
          offset = (offsetHours * 60 + offsetMinutes) * (match[9] === '+' ? 1 : -1);
        }
        return naiveUTC - offset * 60000;
      }

      preview(message) {
        this.hidden = false;
        this.dataset.preview = 'true';
        this.renderSeconds(131696, false);
        this.showNote(message);
      }

      showNote(message) {
        if (!this._note) return;
        this._note.textContent = message;
        this._note.hidden = false;
      }

      tick() {
        const remaining = Math.max(0, Math.ceil((this._deadline - Date.now()) / 1000));
        this.renderSeconds(remaining, true);
        if (remaining === 0) this.expire();
      }

      renderSeconds(total, animate) {
        const hasDays = this.dataset.showDays === 'true';
        const values = {
          days: Math.floor(total / 86400),
          hours: hasDays ? Math.floor(total / 3600) % 24 : Math.floor(total / 3600),
          minutes: Math.floor(total / 60) % 60,
          seconds: total % 60
        };
        Object.entries(this._nodes).forEach(([key, node]) => {
          const value = String(values[key]).padStart(2, '0');
          if (node.textContent === value) return;
          const wasInitialized = node.dataset.initialized === 'true';
          node.textContent = value;
          node.dataset.initialized = 'true';
          node.style.setProperty('--dkot-number-scale', String(Math.min(1, 2.1 / value.length)));
          if (animate && wasInitialized && this._animate && !this._reduceMotion.matches && !document.hidden && typeof node.animate === 'function') {
            const frames = this._animationStyle === 'fade'
              ? [{ opacity: 0.35 }, { opacity: 1 }]
              : this._animationStyle === 'slide'
                ? [{ opacity: 0.45, transform: 'translateY(-3px)' }, { opacity: 1, transform: 'translateY(0)' }]
                : [{ opacity: 0.45, transform: 'perspective(160px) rotateX(-45deg) translateY(2px)' }, { opacity: 1, transform: 'perspective(160px) rotateX(0deg) translateY(0)' }];
            node.getAnimations().forEach((animation) => animation.cancel());
            node.animate(frames, { duration: this._animationDuration, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
          }
        });
        if (this._accessible) {
          const labels = {
            days: this.dataset.labelDays || 'zile', hours: this.dataset.labelHours || 'ore',
            minutes: this.dataset.labelMinutes || 'minute', seconds: this.dataset.labelSeconds || 'secunde'
          };
          const readable = Object.keys(this._nodes).map((key) => `${values[key]} ${labels[key]}`).join(', ');
          const text = `${this.dataset.accessiblePrefix || 'Timp rămas:'} ${readable}`;
          if (text !== this._lastAccessible) {
            this._accessible.textContent = text;
            this._lastAccessible = text;
          }
        }
      }

      expire() {
        if (this._expired) return;
        this._expired = true;
        this.dataset.expired = 'true';
        this.stop();
        const action = this.dataset.expiredAction || 'hide';
        if (action === 'hide' && !this._editor) {
          this.hidden = true;
        } else if (action !== 'zero') {
          this._activeRow.hidden = true;
          this._expiredRow.hidden = false;
        }
        if (this._editor && action === 'hide') this.showNote('Data campaniei a trecut. Bara este ascunsă pe site, conform setării de la expirare.');
        this.dispatchEvent(new CustomEvent('dropky:countdown:expired', {
          bubbles: true,
          detail: { sectionId: this.id, deadline: new Date(this._deadline).toISOString() }
        }));
      }
    }

    customElements.define(elementName, DropkyOfferCountdown);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colecte-prod"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('dropky-game-picks')) return;
    class DropkyGamePicks extends HTMLElement {
      connectedCallback() {
        if (this.dgpAbort) return;
        this.dgpAbort = new AbortController();
        const signal = this.dgpAbort.signal;
        this.dgpCards = Array.from(this.querySelectorAll('[data-dgp-card]'));
        this.dgpButtons = Array.from(this.querySelectorAll('[data-dgp-filter]'));
        this.dgpMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.dgpPointerMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.dgpFrame = 0;
        this.dgpPause = this.querySelector('[data-dgp-pause]');
        const counts = {
          all: this.dgpCards.length,
          sale: this.dgpCards.filter(card => card.dataset.sale === 'true').length,
          preorder: this.dgpCards.filter(card => card.dataset.preorder === 'true').length
        };
        this.dgpButtons.forEach(button => {
          const name = button.dataset.dgpFilter;
          button.hidden = name !== 'all' && !counts[name];
          const counter = button.querySelector('[data-dgp-count]');
          if (counter) counter.textContent = String(counts[name] || 0);
          button.addEventListener('click', () => this.dgpFilter(name), { signal });
        });
        const filters = this.querySelector('[data-dgp-filters]');
        if (filters) filters.hidden = this.dgpCards.length === 0;
        if (this.dgpPause) {
          this.dgpPause.hidden = this.dgpMedia.matches;
          this.dgpPause.addEventListener('click', () => {
            const paused = this.dataset.paused !== 'true';
            this.dataset.paused = String(paused);
            this.dgpPause.setAttribute('aria-pressed', String(paused));
            this.dgpPause.setAttribute('aria-label', paused ? this.dataset.resumeLabel : this.dataset.pauseLabel);
            this.dgpResetTilt();
          }, { signal });
        }
        this.dgpMotionChange = () => {
          if (this.dgpPause) this.dgpPause.hidden = this.dgpMedia.matches;
          if (this.dgpMedia.matches) this.dgpResetTilt();
        };
        this.dgpMedia.addEventListener('change', this.dgpMotionChange);

        if (this.dataset.motion === 'true' && !this.dgpMedia.matches && 'IntersectionObserver' in window) {
          this.dgpObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-revealed');
              this.dgpObserver.unobserve(entry.target);
            });
          }, { threshold: 0.06 });
          this.dgpCards.forEach(card => this.dgpObserver.observe(card));
        }

        if (this.dataset.tilt === 'true' && this.dataset.motion === 'true') {
          this.addEventListener('pointermove', event => {
            if (this.dgpMedia.matches || !this.dgpPointerMedia.matches || this.dataset.paused === 'true') return;
            const card = event.target.closest('.dgp__card-link');
            if (!card || !this.contains(card)) return;
            this.dgpPointer = { card, x: event.clientX, y: event.clientY };
            if (this.dgpFrame) return;
            this.dgpFrame = requestAnimationFrame(() => {
              this.dgpFrame = 0;
              if (!this.dgpPointer) return;
              const { card: active, x, y } = this.dgpPointer;
              const rect = active.getBoundingClientRect();
              if (!rect.width || !rect.height) return;
              if (this.dgpActiveCard && this.dgpActiveCard !== active) {
                this.dgpActiveCard.style.removeProperty('--dgp-rx');
                this.dgpActiveCard.style.removeProperty('--dgp-ry');
              }
              this.dgpActiveCard = active;
              const rx = Math.max(-2.4, Math.min(2.4, (0.5 - (y - rect.top) / rect.height) * 4.8));
              const ry = Math.max(-2.4, Math.min(2.4, ((x - rect.left) / rect.width - 0.5) * 4.8));
              active.style.setProperty('--dgp-rx', rx.toFixed(2) + 'deg');
              active.style.setProperty('--dgp-ry', ry.toFixed(2) + 'deg');
            });
          }, { signal, passive: true });
          this.addEventListener('pointerleave', () => this.dgpResetTilt(), { signal });
          this.addEventListener('pointerout', event => {
            const card = event.target.closest('.dgp__card-link');
            if (card && (!event.relatedTarget || !card.contains(event.relatedTarget))) this.dgpResetTilt();
          }, { signal });
        }
        document.addEventListener('shopify:block:select', event => {
          if (!(event.target instanceof Element) || !this.contains(event.target)) return;
          const card = event.target.closest('[data-dgp-card]');
          if (!card) return;
          this.dgpFilter('all');
          card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        }, { signal });
      }

      dgpFilter(name) {
        this.dgpResetTilt();
        let visible = 0;
        this.dgpCards.forEach(card => {
          const matches = name === 'all' || card.dataset[name] === 'true';
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        this.dgpButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dgpFilter === name)));
        const total = this.querySelector('[data-dgp-total]');
        if (total) total.textContent = String(visible);
        const empty = this.querySelector('[data-dgp-empty]');
        if (empty) empty.hidden = visible !== 0;
        const grid = this.querySelector('[data-dgp-grid]');
        if (grid) grid.scrollLeft = 0;
      }

      dgpResetTilt() {
        if (this.dgpFrame) cancelAnimationFrame(this.dgpFrame);
        this.dgpFrame = 0;
        this.dgpPointer = null;
        if (!this.dgpActiveCard) return;
        this.dgpActiveCard.style.removeProperty('--dgp-rx');
        this.dgpActiveCard.style.removeProperty('--dgp-ry');
        this.dgpActiveCard = null;
      }

      disconnectedCallback() {
        if (this.dgpAbort) this.dgpAbort.abort();
        if (this.dgpObserver) this.dgpObserver.disconnect();
        if (this.dgpMedia && this.dgpMotionChange) this.dgpMedia.removeEventListener('change', this.dgpMotionChange);
        this.dgpResetTilt();
        this.dgpAbort = null;
        this.dgpObserver = null;
      }
    }
    customElements.define('dropky-game-picks', DropkyGamePicks);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colectie-produse"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('dropky-product-shelf')) {

    class DropkyProductShelf extends HTMLElement {

      connectedCallback() {

        queueMicrotask(() => this.initialize());

      }

      disconnectedCallback() {

        if (this.controller) this.controller.abort();

        this.initialized = false;

      }

      normalize(value) {

        return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('ro').trim();

      }

      initialize() {

        if (this.initialized || !this.isConnected) return;

        this.grid = this.querySelector('[data-dps-grid]');

        if (!this.grid) return;

        this.initialized = true;

        this.controller = new AbortController();

        const options = { signal: this.controller.signal };

        this.cards = Array.from(this.grid.querySelectorAll('[data-dps-card]'));

        this.filters = this.querySelector('[data-dps-filters]');

        this.search = this.querySelector('[data-dps-search]');

        this.sort = this.querySelector('[data-dps-sort]');

        this.empty = this.querySelector('[data-dps-empty]');

        this.result = this.querySelector('[data-dps-result]');

        this.activeCategory = '';
        this.editorSelectedBlockId = '';
        this.desktopMedia = window.matchMedia('(min-width: 750px)');
        this.buildFilters();

        this.querySelector('[data-dps-toolbar]').hidden = !(this.search || this.sort || !this.filters.hidden);

        this.addEventListener('click', (event) => {

          const filter = event.target.closest('[data-dps-category]');

          if (filter && this.contains(filter)) {

            this.activeCategory = filter.dataset.dpsCategory;

            this.apply();

          }

          if (event.target.closest('[data-dps-reset]')) this.reset();

        }, options);

        if (this.search) this.search.addEventListener('input', () => this.apply(), options);

        if (this.sort) this.sort.addEventListener('change', () => this.apply(), options);

        document.addEventListener('shopify:block:select', (event) => {

          if (!event.detail) return;

          if (event.detail.sectionId && String(event.detail.sectionId) !== this.dataset.sectionId) return;

          const card = this.cards.find((element) => element.dataset.blockId === String(event.detail.blockId));

          if (!card) return;

          this.editorSelectedBlockId = String(event.detail.blockId);
          this.reset();
          card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });

        }, options);

        const handleLayoutChange = () => this.apply();
        if (this.desktopMedia.addEventListener) {
          this.desktopMedia.addEventListener('change', handleLayoutChange, options);
        } else {
          window.addEventListener('resize', handleLayoutChange, options);
        }
        document.addEventListener('shopify:block:deselect', (event) => {
          if (this.editorSelectedBlockId && event.detail && String(event.detail.blockId) === this.editorSelectedBlockId) {
            this.editorSelectedBlockId = '';
            this.apply();
          }
        }, options);
        this.apply();

    }

    buildFilters() {

        this.filters.replaceChildren();

        const categories = new Map();

        this.cards.forEach((card) => {

          const label = (card.dataset.category || '').trim();

          const key = this.normalize(label);

          if (!key) return;

          const category = categories.get(key) || { label, count: 0 };

          category.count += 1;

          categories.set(key, category);

        });

        if (this.dataset.showFilters !== 'true' || categories.size < 2) {

          this.filters.hidden = true;

          return;

        }

        this.filters.hidden = false;

        const addButton = (key, label, count) => {

          const button = document.createElement('button');

          button.type = 'button';

          button.className = 'dps__filter';

          button.dataset.dpsCategory = key;

          button.setAttribute('aria-pressed', key === '' ? 'true' : 'false');

          button.setAttribute('aria-controls', this.grid.id);

          const text = document.createElement('span');

          text.textContent = label;

          const counter = document.createElement('span');

          counter.className = 'dps__filter-count';

          counter.textContent = count;

          counter.setAttribute('aria-hidden', 'true');

          button.append(text, counter);

          this.filters.append(button);

        };

        addButton('', this.dataset.allLabel || 'Toate', this.cards.length);

        categories.forEach((category, key) => addButton(key, category.label, category.count));

      }

      reset() {

        this.activeCategory = '';

        if (this.search) this.search.value = '';

        if (this.sort) this.sort.value = 'manual';

        this.apply();

      }

      apply() {

        const query = this.normalize(this.search ? this.search.value : '');

        const words = query.split(/\s+/).filter(Boolean);

        const sortMode = this.sort ? this.sort.value : 'manual';

        let matchCount = 0;
        const desktopLimit = Math.max(1, Number(this.dataset.desktopLimit) || 5);
        const mobileLimit = Math.max(1, Number(this.dataset.mobileLimit) || 6);
        const limit = this.desktopMedia && this.desktopMedia.matches ? desktopLimit : mobileLimit;

        const sorted = this.cards.slice().sort((left, right) => {

          if (sortMode !== 'manual') {

            const placeholderDifference = Number(left.dataset.placeholder === 'true') - Number(right.dataset.placeholder === 'true');

            if (placeholderDifference) return placeholderDifference;

          }

          if (sortMode === 'price-asc' || sortMode === 'price-desc') {

            const difference = Number(left.dataset.price) - Number(right.dataset.price);

            if (difference) return sortMode === 'price-desc' ? -difference : difference;

          }

          if (sortMode === 'title') {

            const difference = (left.dataset.title || '').localeCompare(right.dataset.title || '', 'ro', { sensitivity: 'base' });

            if (difference) return difference;

          }

          return Number(left.dataset.index) - Number(right.dataset.index);

        });

        const fragment = document.createDocumentFragment();

        sorted.forEach((card) => {

          const categoryMatches = !this.activeCategory || this.normalize(card.dataset.category) === this.activeCategory;

          const haystack = this.normalize(card.dataset.search);

          const queryMatches = words.every((word) => haystack.includes(word));

          const matches = categoryMatches && queryMatches;
          if (matches) matchCount += 1;
          const selectedInEditor = this.editorSelectedBlockId && card.dataset.blockId === this.editorSelectedBlockId;
          card.hidden = !(selectedInEditor || (matches && matchCount <= limit));

          fragment.append(card);

        });

        this.grid.append(fragment);

        this.filters.querySelectorAll('[data-dps-category]').forEach((button) => {

          button.setAttribute('aria-pressed', button.dataset.dpsCategory === this.activeCategory ? 'true' : 'false');

        });

        this.empty.hidden = matchCount !== 0;
        this.result.hidden = false;

      }

    }

    customElements.define('dropky-product-shelf', DropkyProductShelf);

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dece-asa-ieftin"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.customElements || customElements.get('dropky-source-note')) return;
    class DropkySourceNote extends HTMLElement {
      connectedCallback() { this.frame = requestAnimationFrame(() => this.setup()); }
      setup() {
        if (this.ready || !this.isConnected) return;
        this.ready = true;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.art = this.querySelector('.dsn-art');
        this.query = matchMedia('(prefers-reduced-motion: reduce)');
        this.pointerQuery = matchMedia('(hover: hover) and (pointer: fine)');
        this.inView = false;
        this.hasPlayed = this.hasPlayed || false;
        this.complete = this.complete || false;
        this.classList.add('is-visible');

        this.motionChange = () => this.updatePlayback();
        if (this.query.addEventListener) this.query.addEventListener('change', this.motionChange);
        else this.query.addListener(this.motionChange);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal });
        this.art?.addEventListener('animationend', (event) => {
          if (event.animationName !== 'dsn-settle-v5') return;
          this.complete = true;
          this.classList.add('is-delivered');
        }, { signal });

        this.art?.addEventListener('pointermove', (event) => {
          if (!this.running || !this.pointerQuery.matches) return;
          const rect = this.art.getBoundingClientRect();
          const x = (event.clientX - rect.left) / Math.max(rect.width, 1) - .5;
          const y = (event.clientY - rect.top) / Math.max(rect.height, 1) - .5;
          cancelAnimationFrame(this.tiltFrame);
          this.tiltFrame = requestAnimationFrame(() => {
            this.art.style.setProperty('--dsn-rx', `${(-y * 4).toFixed(2)}deg`);
            this.art.style.setProperty('--dsn-ry', `${(x * 4).toFixed(2)}deg`);
          });
        }, { signal, passive: true });
        this.art?.addEventListener('pointerleave', () => this.resetTilt(), { signal });

        this.querySelector('[data-dsn-cta]')?.addEventListener('click', (event) => {
          const link = event.currentTarget;
          if (link.dataset.target !== 'previous' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          const wrapper = this.closest('.shopify-section');
          let previous = wrapper?.previousElementSibling;
          while (previous && ['SCRIPT', 'STYLE', 'LINK', 'TEMPLATE'].includes(previous.tagName)) previous = previous.previousElementSibling;
          if (!previous || !previous.classList.contains('shopify-section')) return;
          event.preventDefault();
          const offset = Math.max(0, Number(link.dataset.offset) || 0);
          const top = Math.max(0, previous.getBoundingClientRect().top + window.scrollY - offset);
          window.scrollTo({ top, behavior: this.motionAllowed() ? 'smooth' : 'auto' });
        }, { signal });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
            this.updatePlayback();
          }, { threshold: .12 });
          this.observer.observe(this.art || this);
        } else this.inView = true;
        this.updatePlayback();
        this.classList.add('is-ready');
      }
      motionAllowed() { return this.dataset.motion === 'true' && !this.query.matches; }
      updatePlayback() {
        this.dataset.reduced = String(this.query.matches);
        this.running = Boolean(this.art && this.motionAllowed() && this.inView && !document.hidden);
        this.dataset.running = String(this.running);
        if (!this.motionAllowed() || !this.art) {
          this.hasPlayed = true;
          this.complete = true;
          this.classList.remove('is-playing');
          this.classList.add('is-delivered');
        } else if (this.running && !this.hasPlayed) {
          this.hasPlayed = true;
          this.classList.add('is-playing');
        }
        if (!this.running) this.resetTilt();
      }
      resetTilt() {
        cancelAnimationFrame(this.tiltFrame);
        this.art?.style.removeProperty('--dsn-rx');
        this.art?.style.removeProperty('--dsn-ry');
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.controller?.abort();
        this.resetTilt();
        if (this.query && this.motionChange) {
          if (this.query.removeEventListener) this.query.removeEventListener('change', this.motionChange);
          else this.query.removeListener(this.motionChange);
        }
        this.dataset.running = 'false';
        this.ready = false;
        this.classList.remove('is-ready');
      }
    }
    customElements.define('dropky-source-note', DropkySourceNote);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dropky-roblox-world"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.customElements || customElements.get('dropky-roblox-world')) return;
    class DropkyRobloxWorld extends HTMLElement {
      connectedCallback() { this.setupFrame = requestAnimationFrame(() => this.setup()); }
      setup() {
        if (this.ready || !this.isConnected) return;
        this.ready = true;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.scene = this.querySelector('.drw-scene');
        this.shop = this.querySelector('.drw-shop');
        this.vault = this.querySelector('.drw-vault');
        this.dock = this.querySelector('[data-drw-dock]');
        this.dockContent = this.querySelector('[data-drw-dock-content]');
        this.packs = Array.from(this.querySelectorAll('[data-drw-pack]'));
        this.offers = Array.from(this.querySelectorAll('[data-drw-offer]'));
        this.amountText = this.querySelector('[data-drw-scene-amount]');
        this.amountTexts = Array.from(this.querySelectorAll('[data-drw-scene-amount]'));
        this.statusText = this.querySelector('[data-drw-status]');
        this.reduceQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.pointerQuery = matchMedia('(hover: hover) and (pointer: fine)');
        this.inView = false;
        this.shopInView = false;
        this.hasSeenShop = this.hasSeenShop || false;
        this.dockDismissed = this.dockDismissed || false;
        this.hasPlayed = this.hasPlayed || false;
        this.complete = this.complete || false;
        this.active = this.packs.find(p => p.dataset.drwPack === this.dataset.selected) || this.packs[0];
        this.displayAmount = Number(this.active?.dataset.amount) || 0;
        if (this.active) this.amountTexts.forEach(node => { node.textContent = this.active.dataset.label; });
        try { this.numberFormat = new Intl.NumberFormat(document.documentElement.lang || 'ro-RO'); }
        catch { this.numberFormat = new Intl.NumberFormat('ro-RO'); }

        this.packs.forEach((pack, index) => {
          pack.setAttribute('role', 'button');
          pack.setAttribute('tabindex', '0');
          pack.setAttribute('aria-pressed', String(pack === this.active));
          pack.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
            event.preventDefault();
            this.select(pack, true);
          }, { signal });
          pack.addEventListener('keydown', event => {
            if (event.key === ' ' || (event.key === 'Enter' && !pack.hasAttribute('href'))) {
              event.preventDefault(); this.select(pack, true); return;
            }
            let next = index;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.packs.length;
            else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + this.packs.length - 1) % this.packs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.packs.length - 1;
            else return;
            event.preventDefault(); this.packs[next].focus(); this.select(this.packs[next], true);
          }, { signal });
        });
        this.scene?.addEventListener('animationend', event => {
          if (event.animationName === 'drw-ready-v1') this.finishIntro();
          if (event.animationName === 'drw-hop-v1') this.endSelection();
        }, { signal });
        this.motionChange = () => this.updatePlayback();
        if (this.reduceQuery.addEventListener) this.reduceQuery.addEventListener('change', this.motionChange);
        else this.reduceQuery.addListener(this.motionChange);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal });
        this.scene?.addEventListener('pointermove', event => {
          if (!this.running || !this.pointerQuery.matches) return;
          const rect = this.scene.getBoundingClientRect();
          const x = (event.clientX - rect.left) / Math.max(rect.width, 1) - .5;
          const y = (event.clientY - rect.top) / Math.max(rect.height, 1) - .5;
          cancelAnimationFrame(this.tiltFrame);
          this.tiltFrame = requestAnimationFrame(() => {
            this.scene.style.setProperty('--drw-rx', `${(-y * 4).toFixed(2)}deg`);
            this.scene.style.setProperty('--drw-ry', `${(x * 4).toFixed(2)}deg`);
          });
        }, { signal, passive: true });
        this.scene?.addEventListener('pointerleave', () => this.resetTilt(), { signal });
        this.querySelectorAll('[data-drw-scroll]').forEach(link => {
          link.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
            const href = link.getAttribute('href');
            const target = href?.startsWith('#') ? document.getElementById(href.slice(1)) : null;
            if (!target || !this.contains(target)) return;
            event.preventDefault();
            target.querySelectorAll('[data-drw-reveal]').forEach(node => node.classList.add('is-revealed'));
            target.classList.add('is-revealed');
            target.scrollIntoView({ behavior: this.motionAllowed() ? 'smooth' : 'auto', block: 'start' });
            const heading = target.matches('h1,h2,h3') ? target : target.querySelector('h1,h2,h3');
            if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
          }, { signal });
        });
        this.querySelector('[data-drw-dock-close]')?.addEventListener('click', () => {
          this.dockDismissed = true; this.updateDock();
        }, { signal });
        this.addEventListener('focusin', event => {
          event.target.closest?.('[data-drw-reveal]')?.classList.add('is-revealed');
        }, { signal });
        window.addEventListener('scroll', () => this.queueScroll(), { signal, passive: true });
        window.addEventListener('resize', () => this.queueScroll(), { signal, passive: true });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.updatePlayback();
          }, { threshold: .12 });
          this.observer.observe(this.scene || this);
          if (this.shop) {
            this.shopObserver = new IntersectionObserver(entries => {
              this.shopInView = entries[0].isIntersecting;
              if (entries[0].intersectionRatio >= .25) this.hasSeenShop = true;
              this.updatePlayback(); this.updateDock();
            }, { threshold: [0,.12,.25] });
            this.shopObserver.observe(this.shop);
          }
          this.revealObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-revealed');
              this.revealObserver.unobserve(entry.target);
            });
          }, { threshold: .12 });
          this.querySelectorAll('[data-drw-reveal]').forEach(node => this.revealObserver.observe(node));
        } else this.inView = true;
        if (!this.motionAllowed() || !('IntersectionObserver' in window)) this.revealAll();
        this.classList.add('js-ready');
        this.syncDock(); this.queueScroll();
        this.updatePlayback();
      }
      motionAllowed() { return this.dataset.motion === 'true' && !this.reduceQuery.matches; }
      updatePlayback() {
        this.dataset.reduced = String(this.reduceQuery.matches);
        this.dataset.documentHidden = String(document.hidden);
        this.running = Boolean(this.scene && this.motionAllowed() && (this.inView || this.shopInView) && !document.hidden);
        this.dataset.running = String(this.running);
        if (!this.motionAllowed() || !this.scene) {
          this.finishIntro(); this.endSelection();
          cancelAnimationFrame(this.counterFrame);
          if (this.active) this.amountTexts.forEach(node => { node.textContent = this.active.dataset.label; });
          this.revealAll();
        } else if (this.running && this.inView && !this.hasPlayed) {
          this.hasPlayed = true;
          this.classList.add('is-playing');
        }
        if (!this.running) this.resetTilt();
      }
      finishIntro() {
        this.hasPlayed = true;
        this.complete = true;
        this.classList.remove('is-playing');
        this.classList.add('is-settled');
      }
      select(pack, animate) {
        if (!pack || pack === this.active) return;
        this.finishIntro();
        this.active = pack;
        this.dataset.selected = pack.dataset.drwPack;
        this.packs.forEach(item => {
          const current = item === pack;
          item.classList.toggle('is-selected', current);
          item.setAttribute('aria-pressed', String(current));
        });
        const offer = this.offers.find(item => item.dataset.drwOffer === pack.dataset.drwPack);
        this.offers.forEach(item => { item.hidden = item !== offer; });
        const color = pack.dataset.worldColor || '';
        if (/^#[\da-f]{3,8}$/i.test(color)) this.style.setProperty('--drw-world', color);
        else this.style.setProperty('--drw-world', 'var(--drw-brand, var(--drw-accent))');
        const price = offer?.querySelector('[data-drw-price]')?.textContent.trim() || '';
        if (this.statusText) this.statusText.textContent = `${pack.dataset.label} ${this.dataset.unit}${price && price !== '—' ? `, ${price}` : ''}`;
        this.updateAmount(pack, animate && this.motionAllowed() && (this.inView || this.shopInView));
        this.endSelection();
        this.dockDismissed = false;
        this.syncDock(); this.updateDock();
        if (animate && this.motionAllowed() && (this.inView || this.shopInView) && this.scene) {
          (this.shop || this.scene).getBoundingClientRect();
          this.classList.add('is-selecting');
          this.selectionTimer = setTimeout(() => this.endSelection(), 1050);
        }
      }
      updateAmount(pack, animate) {
        cancelAnimationFrame(this.counterFrame);
        const end = Number(pack.dataset.amount) || 0;
        const start = this.displayAmount || end;
        if (!this.amountTexts.length || !animate || start === end) {
          this.amountTexts.forEach(node => { node.textContent = pack.dataset.label; });
          this.displayAmount = end; return;
        }
        let began;
        const tick = time => {
          if (!this.isConnected) return;
          if (began === undefined) began = time;
          const progress = Math.min(1, (time - began) / 500);
          this.displayAmount = Math.round(start + (end - start) * (1 - Math.pow(1 - progress, 3)));
          const label = progress < 1 ? this.numberFormat.format(this.displayAmount) : pack.dataset.label;
          this.amountTexts.forEach(node => { node.textContent = label; });
          if (progress < 1) this.counterFrame = requestAnimationFrame(tick);
        };
        this.counterFrame = requestAnimationFrame(tick);
      }
      endSelection() { clearTimeout(this.selectionTimer); this.classList.remove('is-selecting'); }
      revealAll() { this.querySelectorAll('[data-drw-reveal]').forEach(node => node.classList.add('is-revealed')); }
      syncDock() {
        if (!this.dockContent || !this.active) return;
        const offer = this.offers.find(node => node.dataset.drwOffer === this.active.dataset.drwPack);
        if (!offer) return;
        const clone = offer.cloneNode(true);
        clone.removeAttribute('data-drw-offer'); clone.hidden = false;
        this.dockContent.replaceChildren(clone);
      }
      queueScroll() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          if (!this.isConnected) return;
          const rect = this.getBoundingClientRect();
          const progress = Math.max(0,Math.min(1,-rect.top / Math.max(1,rect.height - window.innerHeight)));
          this.style.setProperty('--drw-progress',progress.toFixed(4));
          this.updateDock(rect);
        });
      }
      updateDock(rect) {
        if (!this.dock || !this.shop) return;
        const bounds = rect || this.getBoundingClientRect();
        const inPage = bounds.bottom > 100 && bounds.top < window.innerHeight && bounds.width > 0;
        const passedShop = this.shop.getBoundingClientRect().bottom < 80;
        const buyable = this.active?.dataset.buyable === 'true' && Boolean(this.dockContent?.firstElementChild);
        this.dock.hidden = this.dataset.dock !== 'true' || !buyable || !this.hasSeenShop || !passedShop || !inPage || this.dockDismissed;
      }
      resetTilt() {
        cancelAnimationFrame(this.tiltFrame);
        this.scene?.style.removeProperty('--drw-rx');
        this.scene?.style.removeProperty('--drw-ry');
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.counterFrame);
        cancelAnimationFrame(this.scrollFrame); this.scrollFrame = 0;
        this.endSelection(); this.resetTilt();
        this.observer?.disconnect(); this.events?.abort();
        this.shopObserver?.disconnect(); this.revealObserver?.disconnect();
        if (this.reduceQuery && this.motionChange) {
          if (this.reduceQuery.removeEventListener) this.reduceQuery.removeEventListener('change', this.motionChange);
          else this.reduceQuery.removeListener(this.motionChange);
        }
        this.dataset.running = 'false'; this.ready = false;
      }
    }
    customElements.define('dropky-roblox-world', DropkyRobloxWorld);
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc27-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('dropky-fc27')) return;
    class DropkyFC27 extends HTMLElement {
      connectedCallback() {
        if (this.fcAbort) return;
        this.fcAbort = new AbortController();
        const signal = this.fcAbort.signal;
        this.fcMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.fcPause = this.querySelector('[data-d27-pause]');
        this.fcFormat = new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 0 });
        this.fcPaused = false;
        if (this.fcPause) {
          this.fcPause.hidden = this.fcMedia.matches;
          this.fcPause.addEventListener('click', () => {
            this.fcPaused = !this.fcPaused;
            this.dataset.paused = String(this.fcPaused);
            this.fcPause.setAttribute('aria-pressed', String(this.fcPaused));
            this.fcPause.setAttribute('aria-label', this.fcPaused ? 'Reia animațiile' : 'Oprește animațiile');
          }, { signal });
        }
        this.fcMotionChange = () => { if (this.fcPause) this.fcPause.hidden = this.fcMedia.matches; };
        this.fcMedia.addEventListener('change', this.fcMotionChange);
        if (this.dataset.motion === 'true' && !this.fcMedia.matches && 'IntersectionObserver' in window) {
          this.fcReveal = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-revealed');
              this.fcReveal.unobserve(entry.target);
            });
          }, { threshold: 0.06 });
          this.querySelectorAll('[data-d27-reveal]').forEach(el => this.fcReveal.observe(el));
        }
        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;
          const anchor = event.target.closest('a[href^="#"]');
          if (!anchor || !this.contains(anchor)) return;
          const id = anchor.getAttribute('href').slice(1);
          const target = document.getElementById(id);
          if (!target || !this.contains(target)) return;
          event.preventDefault();
          target.scrollIntoView({ block: 'start', behavior: this.dataset.motion === 'true' && !this.fcMedia.matches && !this.fcPaused ? 'smooth' : 'auto' });
        }, { signal });
        this.fcSetupCounter();
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) return;
          if (this.fcCounterMode === 'estimated') this.fcUpdateEstimate();
          if (this.fcCounterMode === 'endpoint') this.fcFetchCount();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (!(event.target instanceof Element) || !this.contains(event.target)) return;
          const details = event.target.closest('details');
          if (details) details.open = true;
        }, { signal });
      }

      fcSetupCounter() {
        this.fcCounter = this.querySelector('[data-d27-counter]');
        if (!this.fcCounter) return;
        this.fcCounterMode = this.fcCounter.dataset.counterMode;
        this.fcCount = this.fcCounter.querySelector('[data-d27-count]');
        this.fcState = this.fcCounter.querySelector('[data-d27-counter-state]');
        this.fcLabel = this.fcCounter.querySelector('[data-d27-counter-label]');
        this.fcNote = this.fcCounter.querySelector('[data-d27-counter-note]');
        this.fcTime = this.fcCounter.querySelector('[data-d27-counter-time]');
        this.fcBase = Math.max(0, Math.floor(Number(this.fcCounter.dataset.counterBase) || 0));
        this.fcMinutes = Math.max(1, Math.min(60, Number(this.fcCounter.dataset.counterMinutes) || 1));
        if (this.fcCounterMode === 'manual') { this.fcSetCount(this.fcBase); return; }
        if (this.fcCounterMode === 'estimated') {
          const start = this.fcCounter.dataset.counterStart.trim();
          this.fcStart = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:\d{2})$/.test(start) ? Date.parse(start) : NaN;
          this.fcUpdateEstimate();
          this.fcTimer = setInterval(() => { if (!document.hidden) this.fcUpdateEstimate(); }, 1000);
          return;
        }
        if (this.fcCounterMode === 'endpoint') {
          this.fcLastConfirmed = null;
          this.fcFetchCount();
          const refresh = Math.max(15, Math.min(120, Number(this.fcCounter.dataset.counterRefresh) || 30));
          this.fcTimer = setInterval(() => { if (!document.hidden) this.fcFetchCount(); }, refresh * 1000);
        }
      }

      fcSetCount(value) {
        const formatted = this.fcFormat.format(value);
        if (this.fcCount.textContent === formatted) return;
        this.fcCount.textContent = formatted;
        this.fcCount.classList.remove('is-ticking');
        void this.fcCount.offsetWidth;
        if (this.dataset.motion === 'true' && !this.fcMedia.matches && !this.fcPaused) this.fcCount.classList.add('is-ticking');
      }

      fcUpdateEstimate() {
        const elapsed = Date.now() - this.fcStart;
        const interval = this.fcMinutes * 60000;
        if (!Number.isFinite(this.fcStart) || elapsed < 0) {
          this.fcLabel.textContent = 'Ritm mediu estimat';
          this.fcCounter.style.setProperty('--d27-progress', '0');
          return;
        }
        this.fcSetCount(this.fcBase + Math.floor(elapsed / interval));
        this.fcLabel.textContent = 'Vânzări estimate';
        this.fcTime.textContent = 'Estimare pornită: ' + new Date(this.fcStart).toLocaleString('ro-RO', { timeZone: 'Europe/Bucharest', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
        this.fcCounter.style.setProperty('--d27-progress', String((elapsed % interval) / interval));
      }

      async fcFetchCount() {
        if (this.fcFetching || !this.fcAbort || !this.fcCounter) return;
        const lifecycle = this.fcAbort;
        this.fcFetching = true;
        const controller = new AbortController();
        this.fcFetchAbort = controller;
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const raw = this.fcCounter.dataset.counterEndpoint.trim();
          if (!raw) throw new Error('No endpoint');
          const endpoint = new URL(raw, location.origin);
          if (endpoint.protocol !== 'https:' && endpoint.origin !== location.origin) throw new Error('Invalid endpoint');
          const response = await fetch(endpoint.href, { credentials: 'omit', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Counter unavailable');
          const data = await response.json();
          const sold = data.sold;
          const updated = Date.parse(data.updated_at);
          if (!Number.isSafeInteger(sold) || sold < 0 || !Number.isFinite(updated) || updated > Date.now() + 300000) throw new Error('Invalid count');
          if (!this.isConnected || this.fcAbort !== lifecycle || lifecycle.signal.aborted) return;
          this.fcLastConfirmed = sold;
          this.fcSetCount(sold);
          const stale = Date.now() - updated > 300000;
          this.fcState.textContent = stale ? 'ULTIMUL TOTAL CONFIRMAT' : 'DATE DIN COMENZI';
          this.fcLabel.textContent = 'Vânzări confirmate';
          this.fcNote.textContent = 'Total preluat din sursa de comenzi. Numărul se schimbă numai când sursa raportează alte vânzări.';
          this.fcTime.textContent = 'Actualizat: ' + new Date(updated).toLocaleString('ro-RO', { timeZone: 'Europe/Bucharest', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
          this.fcCounter.style.setProperty('--d27-progress', '1');
        } catch (error) {
          if (!this.isConnected || this.fcAbort !== lifecycle || lifecycle.signal.aborted) return;
          this.fcState.textContent = 'ACTUALIZARE INDISPONIBILĂ';
          this.fcNote.textContent = this.fcLastConfirmed === null ? 'Totalul comenzilor nu este disponibil momentan.' : 'Se păstrează ultimul total confirmat. Actualizarea va fi reîncercată.';
          if (this.fcLastConfirmed === null) this.fcCount.textContent = '—';
          this.fcCounter.style.setProperty('--d27-progress', '0');
        } finally {
          clearTimeout(timeout);
          if (this.fcFetchAbort === controller) this.fcFetching = false;
        }
      }

      disconnectedCallback() {
        if (this.fcAbort) this.fcAbort.abort();
        if (this.fcFetchAbort) this.fcFetchAbort.abort();
        if (this.fcReveal) this.fcReveal.disconnect();
        if (this.fcTimer) clearInterval(this.fcTimer);
        if (this.fcMedia && this.fcMotionChange) this.fcMedia.removeEventListener('change', this.fcMotionChange);
        this.fcAbort = null;
        this.fcReveal = null;
        this.fcTimer = null;
        this.fcFetching = false;
      }
    }
    customElements.define('dropky-fc27', DropkyFC27);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-dropky"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('dk-dropky-bite-hero')) return;
  class DropkyBiteHero extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.tick);
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      try { this.product = JSON.parse(this.querySelector('[data-dkyb-product]')?.textContent || '[]')[0] || {}; }
      catch { this.product = {}; }
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false; this.editorPaused = false; this.complete = false;
      this.inView = !('IntersectionObserver' in window);
      this.sceneInView = this.inView;
      this.classList.remove('is-complete');
      this.controls = this.querySelector('[data-dkyb-motion]');
      this.pauseButton = this.querySelector('[data-dkyb-pause]');
      this.timer = this.querySelector('[data-dkyb-timer]');
      this.timerSlot = this.querySelector('[data-dkyb-timer-slot]');
      this.timerHelp = this.querySelector('[data-dkyb-timer-help]');
      this.timerMedia = matchMedia('(min-width:761px)');
      this.timerMedia.addEventListener('change',() => this.relocateTimer(),options);
      this.relocateTimer();
      this.deadline = this.parseDate(this.timer?.dataset.end || '');
      this.expiredSent = false;
      this.addEventListener('click',event => {
        if (event.target.closest('[data-dkyb-replay]')) { this.userPaused = false; this.restart(); this.dispatchEvent(new CustomEvent('dropky:hero-animation-replay',{bubbles:true,detail:this.eventDetail()})); }
        if (event.target.closest('[data-dkyb-pause]')) {
          if (this.complete) { this.userPaused = false; this.restart(); }
          else { this.userPaused = !this.userPaused; this.update(); }
        }
        if (event.target.closest('[data-dkyb-product-link]') && this.product.product) this.dispatchEvent(new CustomEvent('dropky:hero-product-click',{bubbles:true,detail:this.eventDetail()}));
      },options);
      this.addEventListener('animationend',event => {
        if (event.animationName !== 'dkyb-release' || this.dataset.loop !== 'false') return;
        this.complete = true; this.classList.add('is-complete'); this.update();
      },options);
      document.addEventListener('visibilitychange',() => this.update(),options);
      this.motion.addEventListener('change',() => this.update(),options);
      for (const name of ['shopify:block:select','shopify:block:deselect']) document.addEventListener(name,event => {
        if (!this.contains(event.target) && event.target.closest?.('.shopify-section') !== this.closest('.shopify-section')) return;
        this.editorPaused = name.endsWith(':select'); this.update();
      },options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.target===this) this.inView = entry.isIntersecting;
            else this.sceneInView = entry.isIntersecting;
          }
          this.update();
        },{threshold:0.05});
        this.observer.observe(this);
        const art = this.querySelector('.dkyb__art');
        if (art) this.observer.observe(art);
      }
      this.update();
    }
    relocateTimer() {
      if (!this.timerSlot) return;
      const target = this.timerMedia?.matches ? this.querySelector('.dkyb__copy') : this.querySelector('.dkyb__art');
      if (!target || this.timerSlot.parentElement===target) return;
      if (this.timerMedia?.matches) target.append(this.timerSlot);
      else target.prepend(this.timerSlot);
    }
    eventDetail() { return {product_id:this.product.product,variant_id:this.product.variant,source:'dropky_bite_hero'}; }
    parseDate(value) {
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(value.trim());
      if (!match) return NaN;
      const [year,month,day,hour,minute,second] = match.slice(1,7).map(n=>Number(n||0));
      if (year<2000 || month<1 || month>12 || day<1 || hour>23 || minute>59 || second>59) return NaN;
      const utc = Date.UTC(year,month-1,day,hour,minute,second), date = new Date(utc);
      if (date.getUTCFullYear()!==year || date.getUTCMonth()!==month-1 || date.getUTCDate()!==day) return NaN;
      const zone = match[7];
      if (zone==='Z') return utc;
      const zoneHour = Number(zone.slice(1,3)),zoneMinute = Number(zone.slice(4,6));
      if (zoneHour>14 || zoneMinute>59 || (zoneHour===14 && zoneMinute!==0)) return NaN;
      return utc-(zone[0]==='-'?-1:1)*(zoneHour*60+zoneMinute)*60000;
    }
    restart() {
      this.complete = false; this.classList.remove('is-complete','is-enhanced');
      void this.offsetWidth;
      this.update();
    }
    update() {
      const enabled = this.dataset.animation==='true' && !this.motion.matches;
      this.classList.toggle('is-enhanced',enabled);
      this.dataset.playing = String(enabled && this.sceneInView && !document.hidden && !this.userPaused && !this.editorPaused && !this.complete);
      if (this.controls) this.controls.hidden = !enabled;
      if (this.pauseButton) {
        const paused = this.userPaused || this.complete;
        const label = (paused ? this.dataset.resumeLabel : this.dataset.pauseLabel) || (paused ? 'Continuă animația' : 'Pauză animația');
        const text = this.pauseButton.querySelector('[data-dkyb-pause-label]');
        if (text) text.textContent = (paused ? this.dataset.resumeLabel : this.dataset.pauseLabel) || '';
        this.pauseButton.setAttribute('aria-label',label);
        this.pauseButton.setAttribute('aria-pressed',String(paused));
      }
      clearTimeout(this.tick);
      this.updateTimer();
    }
    updateTimer() {
      if (!this.timer || !this.timerSlot) return;
      if (!Number.isFinite(this.deadline)) {
        this.timer.hidden = true;
        this.timerSlot.hidden = this.dataset.editor!=='true';
        this.timerSlot.classList.remove('dkyb__timer-slot--configured');
        if (this.timerHelp) this.timerHelp.hidden = false;
        return;
      }
      if (this.timerHelp) this.timerHelp.hidden = true;
      const seconds = Math.max(0,Math.ceil((this.deadline-Date.now())/1000));
      if (!seconds) {
        this.timerSlot.hidden = this.timer.dataset.expiry==='hide' || !this.timer.dataset.expiredText;
        this.timer.hidden = this.timerSlot.hidden;
        this.timer.classList.add('is-expired');
        this.timer.querySelector('.dkyb__count').hidden = true;
        const expired = this.timer.querySelector('[data-dkyb-expired]');
        expired.textContent = this.timer.dataset.expiredText || '';
        expired.hidden = !expired.textContent;
        if (!this.expiredSent) { this.expiredSent = true; this.dispatchEvent(new CustomEvent('dropky:offer-countdown-expired',{bubbles:true,detail:this.eventDetail()})); }
        return;
      }
      this.timerSlot.hidden = false; this.timer.hidden = false;
      const days = Math.floor(seconds/86400),hours = Math.floor(seconds%86400/3600),minutes = Math.floor(seconds%3600/60),sec = seconds%60;
      const pad = n=>String(n).padStart(2,'0');
      const dayWrap = this.timer.querySelector('[data-dkyb-days-wrap]'),dayNode = this.timer.querySelector('[data-dkyb-days]'),unit = this.timer.querySelector('[data-dkyb-day-unit]'),clock = this.timer.querySelector('[data-dkyb-clock]');
      this.text(dayNode,String(days)); this.text(unit,days===1 ? unit.dataset.singular : unit.dataset.plural);
      if (dayWrap) dayWrap.hidden = days===0;
      this.text(clock,`${pad(hours)}:${pad(minutes)}${this.timer.dataset.seconds==='true'?':'+pad(sec):''}`);
      if (this.inView && !document.hidden) this.tick = setTimeout(()=>this.updateTimer(),this.timer.dataset.seconds==='true'?1000:Math.min(60000,seconds*1000));
    }
    text(node,value) { if (node && node.textContent!==value) node.textContent=value; }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.tick); }
  }
  customElements.define('dk-dropky-bite-hero',DropkyBiteHero);
})();

  } catch(e) { console.error(e); }
})();
})();
